import React from 'react';
import { colors } from '../utils/colors';

const st = {
	maxWidth: '600px',
	padding: '1em',
	fontSize: '1em',
	display: 'inline-block',
	lineHeight: '1.5em',
	margin: '0 auto',
	marginTop: '1.5em',
	marginBottom: 0,
	fontWeight: 300,
	color: `${colors.clave}`,
	textAlign: 'left'
};

const hrst = {
	borderTop: `1px solid ${colors.grisClaro}`
};

const FirmaFinal = props => (
	<div style={st}>
		<div style={hrst} />
		<p>
			<strong style={{ fontWeight: '700' }}>Jesús Benítez,</strong> periodista y
			escritor, fue editor jefe del Diario Marca y, durante más de una década,
			siguió todos los grandes premios del Mundial de Motociclismo. A comienzos
			de los 90, ejerció varios años como jefe de prensa del Circuito de Jerez.
		</p>

		<p>
			Fotos: <strong style={{ fontWeight: '700' }}>Dorna</strong>.
		</p>

		<p>
			Infografía: <strong style={{ fontWeight: '700' }}>Jose A. Álvarez</strong>.
		</p>
	</div>
);

export default FirmaFinal;



// WEBPACK FOOTER //
// ./src/components/FirmaFinal.js